import api from 'api'
import { CACHE_TAG_CALLS_LIST, CACHE_TAG_FOLLOW_UP_LIST } from '../cacheTagTypes'
import { withIdTag } from 'utils/cache'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    addUpdateCallFollowUp: build.mutation({
      query: body => ({ url: '/api/account/call/add', method: 'POST', body }),
      // invalidate both lists; if server returns id in body.call.id, include id-specific tags
      invalidatesTags: (result, error, arg) => [
        ...withIdTag(CACHE_TAG_CALLS_LIST, arg?.call?.id),
        ...withIdTag(CACHE_TAG_FOLLOW_UP_LIST, arg?.call?.id),
      ],
    }),
  }),
})

export const { useAddUpdateCallFollowUpMutation } = extendedApi
